import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ToasterService } from "angular2-toaster";
import { FeedbackType } from "app/feedback/models/feedback-config.model";
import { FeedbackService } from "app/feedback/services/feedback.service";
import { BsModalRef } from "ngx-bootstrap";

@Component({
  selector: "app-job-offer-feedback",
  templateUrl: "./job-offer-feedback.component.html",
  styleUrls: ["./job-offer-feedback.component.scss"],
})
export class JobOfferFeedbackComponent implements OnInit {
  public max: number = 5;

  public form: FormGroup = new FormGroup({
    rating: new FormControl(0, [Validators.required]),
    comment: new FormControl("", []),
  });

  @Output() onSucces: EventEmitter<any> = new EventEmitter<any>();
  @Output() onError: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private bsModal: BsModalRef,
    private feedbackService: FeedbackService
  ) {}

  ngOnInit() {}

  async onSubmit() {
    const body = this.form.getRawValue();
    try {
      const result = await this.feedbackService
        .createFeedback(FeedbackType.JOBOFFER, body.rating, body.comment)
        .toPromise();

      if (result) {
        this.onSucces.emit();
        this.bsModal.hide();
      } else {
        this.onError.emit();
      }
    } catch (e) {
      this.onError.emit();
    }
  }
}
